// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"ceffbb0b","527":"2eb0bf98"}[chunkId] + ".chunk.js";
};